module.exports = __webpack_public_path__ + "static/media/book-medical.7733fd41.svg";